<div class="app-dialog edit-datasource-dialog">
  <div class="app-dialog__heading">
    <button mat-icon-button type="button" class="edit-datasource-dialog-close" aria-label="Close" (click)="onCancel()">
      <mat-icon>close</mat-icon>
    </button>
    <div class="app-dialog__heading-copy">
      <span class="app-dialog__eyebrow">Data source</span>
      <div class="app-dialog__title-row">
        <div class="app-dialog__title-copy">
          <h2 mat-dialog-title class="app-dialog__title">Edit Data Source</h2>
          <p>Update the data source details and configuration.</p>
        </div>
      </div>
    </div>
  </div>
  
  <mat-dialog-content class="app-dialog__content">
    <div *ngIf="loadingData" class="loading-overlay">
      <mat-spinner diameter="40"></mat-spinner>
      <p>Loading data source details...</p>
    </div>

    <div *ngIf="!loadingData">
      <div *ngIf="error" class="error-message">
        <mat-icon>error</mat-icon>
        <span>{{ error }}</span>
      </div>

      <div class="form-section">
        <h3>Basic Information</h3>
        
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Data Source Name</mat-label>
          <input matInput [(ngModel)]="dataSourceName" placeholder="Enter data source name" required>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Tags (comma-separated)</mat-label>
          <input matInput [(ngModel)]="tags" placeholder="e.g., sales, 2024, quarterly">
        </mat-form-field>
      </div>

      <!-- Upload File Type Specific -->
      <div *ngIf="isUploadFileType()" class="form-section">
        <h3>File Management</h3>
        <app-edit-file-upload-datasource 
          [dataSource]="dataSource">
        </app-edit-file-upload-datasource>
      </div>

      <!-- API Listener Type Specific -->
      <div *ngIf="isApiListenerType()" class="form-section">
        <h3>API Listener Configuration</h3>
        <app-edit-api-listener-datasource 
          [dataSource]="dataSource">
        </app-edit-api-listener-datasource>
      </div>

      <div *ngIf="loading" class="loading-overlay">
        <mat-spinner diameter="40"></mat-spinner>
        <p>Processing...</p>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="app-dialog__actions">
    <button mat-button 
            color="warn"
            [disabled]="loading || loadingData"
            (click)="onDelete()"
            class="delete-button">
      <mat-icon svgIcon="delete"></mat-icon>
      Delete
    </button>
    <div style="flex: 1;"></div>
    <button mat-button (click)="onCancel()" [disabled]="loading">Cancel</button>
    <button mat-raised-button color="primary" (click)="onSave()" [disabled]="loading || loadingData || !dataSourceName.trim()">
      Save Changes
    </button>
  </mat-dialog-actions>
</div>
